const today = new Date();
export const Year = today.getFullYear();
const currentYear = String(Year);

export default currentYear;
